import type { SVGProps } from 'react';
const SvgCreatorVk = ({ width = 16, height = 16, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <rect width={16} height={16} fill="#0F81FF" rx={8} />
    <path
      fill="#fff"
      d="M12.91 10.352c-.026-.048-.192-.428-.992-1.208-.838-.818-.725-.685.283-2.1.615-.86.86-1.386.784-1.61-.073-.215-.525-.159-.525-.159l-1.503.01s-.111-.016-.194.036c-.081.051-.133.17-.133.17s-.238.666-.556 1.232c-.669 1.196-.937 1.26-1.047 1.185-.254-.173-.19-.696-.19-1.066 0-1.159.167-1.642-.326-1.767-.164-.041-.284-.069-.702-.074-.536-.006-.99.002-1.247.134-.172.089-.304.285-.223.296.1.014.325.064.444.235.154.22.149.716.149.716s.088 1.364-.207 1.533c-.203.116-.481-.12-1.078-1.206-.306-.555-.537-1.17-.537-1.17s-.045-.114-.124-.175c-.096-.075-.231-.098-.231-.098l-1.43.009s-.214.006-.292.104c-.07.088-.006.268-.006.268s1.119 2.752 2.385 4.14c1.162 1.271 2.481 1.188 2.481 1.188h.598s.18-.021.272-.126c.085-.096.082-.276.082-.276s-.012-.843.36-.967c.367-.123.839.815 1.338 1.175.378.273.665.213.665.213l1.335-.02s.7-.045.368-.622"
    />
  </svg>
);
export default SvgCreatorVk;
